import ARROW_LEFT from '@/assets/icons/arrow-left.svg';
import ARROW_DOWN from '@/assets/icons/arrow-down.svg';
import MORE_ICON from '@/assets/icons/more.svg';
import HELP from '@/assets/icons/help.svg';
import ARROW_SELECT from '@/assets/icons/arrow-select.svg';
import APPENDED_ICON from '@/assets/icons/appended-outer-icon.svg';
import APPENDED_ICON_ZOOM from '@/assets/icons/appended-outer-icon-zoom.svg';
import PREPENDED_LETTER from '@/assets/icons/prepended-letter.svg';
import PREPENDED_LINE from '@/assets/icons/prepended-line.svg';
import PREPENDED_FONT_SIZE from '@/assets/icons/prepended-font-size.svg';
import TEXT_UPPERCASE from '@/assets/icons/text-uppercase.svg';
import TEXT_LOWERCASE from '@/assets/icons/text-lowercase.svg';
import TEXT_CAPITALIZE from '@/assets/icons/text-capitalize.svg';
import ACTIVE_MENU from '@/assets/icons/active-menu.svg';
import ACTIVE_MENU_GRAY from '@/assets/icons/active-menu-gray.svg';
import EYE_DROPPER from '@/assets/icons/eye-dropper.svg';
import ARROW_RIGHT from '@/assets/icons/collapse.svg';
import SUCCESS from '@/assets/icons/success.svg';
import DIRECTIONS from '@/assets/icons/directions.svg';
import VERTICAL_DISTRIBUTE from '@/assets/icons/vertical-distribute.svg';
import HORIZONTAL_DISTRIBUTE from '@/assets/icons/horizontal-distribute.svg';
import ALIGN_VERTICAL_BOTTOM from '@/assets/icons/align-vertical-bottom.svg';
import ALIGN_VERTICAL_CENTER from '@/assets/icons/align-vertical-center.svg';
import ALIGN_VERTICAL_TOP from '@/assets/icons/align-vertical-top.svg';
import ALIGN_HORIZONTAL_CENTER from '@/assets/icons/align-horizontal-center.svg';
import ALIGN_HORIZONTAL_LEFT from '@/assets/icons/align-horizontal-left.svg';
import ALIGN_HORIZONTAL_RIGHT from '@/assets/icons/align-horizontal-right.svg';
import WARNING_LOW_RES_PHOTO from '@/assets/icons/warning.svg';

export const ICON_LOCAL = {
  ARROW_LEFT,
  HELP,
  ARROW_DOWN,
  MORE_ICON,
  ARROW_SELECT,
  APPENDED_ICON,
  APPENDED_ICON_ZOOM,
  PREPENDED_LETTER,
  PREPENDED_LINE,
  PREPENDED_FONT_SIZE,
  TEXT_UPPERCASE,
  TEXT_LOWERCASE,
  TEXT_CAPITALIZE,
  ACTIVE_MENU,
  ACTIVE_MENU_GRAY,
  EYE_DROPPER,
  ARROW_RIGHT,
  SUCCESS,
  DIRECTIONS,
  VERTICAL_DISTRIBUTE,
  ALIGN_VERTICAL_BOTTOM,
  ALIGN_VERTICAL_CENTER,
  ALIGN_HORIZONTAL_LEFT,
  ALIGN_HORIZONTAL_RIGHT,
  ALIGN_HORIZONTAL_CENTER,
  ALIGN_VERTICAL_TOP,
  HORIZONTAL_DISTRIBUTE,
  WARNING_LOW_RES_PHOTO
};
